import { useEffect } from "react";
import { GENERAL_PAGE_TITLE } from "../constants";
import { usePortalArenaContext } from "../PortalArenaContext";

/**
 * Sets the title of document/page. This will show the title passed in plus either an arena name
 * if one is in the portal arena context or "Juniper Square" if not.
 *
 * @param documentTitle The title of the document (minus the optional arena/'Juniper Square').
 * @param arenaDomain OPTIONAL param, only use if in preview
 */
export const useSetDocumentTitle = (
  documentTitle: string | undefined,
  arenaDomain?: string,
) => {
  const arena = usePortalArenaContext();
  const arenaName = arenaDomain ?? arena?.name;
  useEffect(() => {
    if (documentTitle === undefined) {
      document.title = GENERAL_PAGE_TITLE;
    } else {
      const documentTitleSuffix = arenaName ?? GENERAL_PAGE_TITLE;
      document.title = `${documentTitle} - ${documentTitleSuffix}`;
    }
  }, [arenaName, documentTitle]);
};
